import React from "react";
import {
  Backdrop,
  Box,
  Paper,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  containerStyle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
    width: 400,
    height: 300,
    backgroundColor: "white",
    borderRadius: 4,
  },
  textStyle: {
    marginTop: 60,
    margin: 20,
    display: "flex",
    flexWrap: "wrap",
    textAlign: "center",
  },
}));

const LoadMoreItems = ({ loading }) => {
  const classes = useStyles();
  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <Paper elevation={2} className={classes.paperStyle}>
          <div className={classes.containerStyle}>
            <CircularProgress size={90} color="primary" />
            <Typography className={classes.textStyle}>
              Please wait, we are loading more content.
            </Typography>
          </div>
        </Paper>
      </Backdrop>
    </>
  );
};

export default LoadMoreItems;
